import { render, staticRenderFns } from "./debt-management-advisor-tabbed-section.vue?vue&type=template&id=720d80b2"
import script from "./debt-management-advisor-tabbed-section.vue?vue&type=script&lang=js"
export * from "./debt-management-advisor-tabbed-section.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/amortization-breakdown-graph.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports